module.exports = __webpack_public_path__ + "static/assets/619a1ef5fb092487b6bb0a2b740e75eb.svg";